import {
  IsOptional,
  IsIn,
  IsUUID,
  IsInt,
  ValidateIf,
  IsNotEmpty,
  Min,
  Max,
  IsString,
} from 'class-validator';

import type {
  DeadlineOutcome,
  DeadlineReference,
  DeadlineUnit,
} from '@vk-hr-tek/ui/FlowTree';

const MIN_TERM = -1200;
const MAX_TERM = 1200;

export class DeadlineDto {
  @IsIn([
    'event_deadline',
    'node_active',
    'attribute',
    'created_date',
    'created_datetime',
  ])
  @IsNotEmpty({ message: 'Обязательное поле' })
  reference: DeadlineReference;

  @ValidateIf((deadine: DeadlineDto) => deadine.reference === 'attribute')
  @IsUUID()
  @IsNotEmpty({ message: 'Обязательное поле' })
  attribute?: string;

  @IsString()
  @IsOptional()
  attributeName?: string;

  @IsIn(['workday', 'day', 'hour', 'minute'])
  @IsNotEmpty({ message: 'Обязательное поле' })
  unit: DeadlineUnit;

  @IsInt({ message: 'Вы ввели некорректное количество' })
  @IsNotEmpty({ message: 'Вы забыли ввести количество' })
  @Min(MIN_TERM, {
    message: `Допустимо значение от ${MIN_TERM} до ${MAX_TERM} включительно`,
  })
  @Max(MAX_TERM, {
    message: `Допустимо значение от ${MIN_TERM} до ${MAX_TERM} включительно`,
  })
  term: number;

  @IsIn(['true', 'false'])
  @IsOptional()
  round?: 'true' | 'false';

  @IsIn(['to_paper', 'cancel', 'skip'])
  @IsNotEmpty({ message: 'Обязательное поле' })
  outcome: DeadlineOutcome;
}
